import { Card, Icon, Button, Divider, Slider, Spin } from "antd";
import Zillow from "./images/bfile-zillow-zestimates.png";
import { Translate } from "react-translated";
import React, { Component } from "react";
import { AutoComplete } from "antd";
import F from "../../../Functions";
import axios from "axios";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class ZillowHomeValueContainer extends Component {
  state = {
    zillow_loading: false,
    dataSource: [],
    addresses: {},
    zpid: null
  };

  componentDidMount = () => {
    if (
      this.props.wizard.zillow_address &&
      this.props.wizard.zillow_address !== ""
    ) {
      this.handleSearch(this.props.wizard.zillow_address);
    }
  };

  zillowChecker = () => {
    if (this.state.zpid) {
      const { updateField } = this.props;

      // get Range Values
      const rangeValues = F.getRangeValues();

      this.setState({ zillow_loading: true });
      axios.get("/api/zestimate-checker/" + this.state.zpid).then((res) => {
        const zillow_estimated_value = res.data;
        let range = null;
        let home_market_value = "";
        for (let i = 0, len = rangeValues.length; i < len; i++) {
          range = F.rangeToArray(rangeValues[i]);
          if (
            zillow_estimated_value >= range[0] &&
            zillow_estimated_value <= range[1]
          ) {
            home_market_value = rangeValues[i];
          }
        }
        if (zillow_estimated_value > 1000000) {
          home_market_value = "$900,001-$1,000,000";
        }

        updateField("zillow_estimated_value", zillow_estimated_value);
        updateField("home_market_value", home_market_value);
        this.setState({ zillow_loading: false });
      });
    }
  };
  handleSearch = (query) => {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      axios
        .post("/api/zestimate-suggestions", {
          address: query
        })
        .then((res) => {
          F.log("Rsponse >", res.data);
          const dataSource = [];
          const addresses = {};
          let zpid = null;
          if (res.data.results) {
            if (res.data.results.length) {
              F.log("res.data.results = > ", res.data.results);
              for (var j = 0; j < res.data.results.length; j++) {
                const address = res.data.results[j];
                if (address.resultType === "Address") {
                  dataSource.push(address.display);
                  if (!zpid) {
                    zpid = address.metaData.zpid;
                  }

                  var addr = [];
                  if (typeof address.metaData.streetNumber !== "undefined") {
                    addr.push(address.metaData.streetNumber);
                  }
                  if (typeof address.metaData.streetName !== "undefined") {
                    addr.push(address.metaData.streetName);
                  }
                  if (address.length > 0) {
                    addr = addr.join(" ");
                  } else {
                    addr = address.display.split(",")[0];
                  }

                  addresses[address.display] = {
                    address: addr,
                    zillow_address: address.display,
                    city: address.metaData.city,
                    state: address.metaData.state,
                    postal_code: address.metaData.zipCode,
                    country: address.metaData.country,
                    zpid: address.metaData.zpid
                  };
                }
              }
              this.setState({ dataSource, addresses, zpid });
            }
          } else {
            F.log("ERROR");
          }
        });
    }, 1000);
  };
  selectAddress(val) {
    const { addresses } = this.state;
    const { updateField } = this.props;

    if (val in addresses) {
      const address = addresses[val];

      updateField("address", address.address);
      updateField("city", address.city);
      updateField("state", address.state);
      updateField("zipcode", address.postal_code);
      updateField("zillow_address", address.zillow_address);
      updateField(
        "zillow_address_cont",
        address.city + " " + address.state + " " + address.postal_code
      );

      if ("setAddress" in this.props) {
        updateField("address", address.address);
      }
      if ("setCity" in this.props) {
        updateField("city", address.city);
      }
      if ("setState" in this.props) {
        updateField("state", address.state);
      }
      if ("setZipCode" in this.props) {
        updateField("zipcode", address.postal_code);
      }
      if ("setCityStateZip" in this.props) {
        updateField(
          "zillow_address_cont",
          address.city + " " + address.state + " " + address.postal_code
        );
      }

      this.setState({ zpid: address.zpid });
    }
  }

  render() {
    const { wizard, updateField } = this.props;
    const { zillow_loading, dataSource } = this.state;

    const marks = F.getMarksRangeValues();

    let home_market_value = 0;
    if (wizard.home_market_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.home_market_value) {
          home_market_value = parseInt(x, 10);
        }
      }
    }

    return (
      <Card
        title={
          <Translate text={`"What's the approximate value of your home?"`} />
        }
        className="wizardBox"
        type="inner"
        style={{ textAlign: "center" }}
      >
        <Slider
          className="rangeSlider"
          marks={marks}
          step={null}
          value={home_market_value}
          included={false}
          tipFormatter={(val) => F.rangeSliderFormatter(val, marks)}
          onChange={(val) =>
            updateField("home_market_value", F.sliderValue(val, marks))
          }
        />
        <div className="sliderValue center-align">
          {wizard.home_market_value || "$0"}
        </div>
        {/* <Divider /> */}
        {/* <Spin indicator={antIcon} spinning={zillow_loading}> */}
          {/* <Card bordered={false} className="zillowCard center-align">
            <div>
              <img src={Zillow} alt="Zillow" />
              <br />
              <div className="zillowEstimatedValue">
                <Translate text={`Estimated Value`} />:{" "}
                <span>
                  {F.dollar_format(wizard.zillow_estimated_value || 0)}
                </span>
              </div>
            </div>
            <Translate text={`Address`} /> {"* "}
            <AutoComplete
              value={wizard.zillow_address}
              dataSource={dataSource}
              style={{ width: "100%" }}
              onChange={(val) => {
                updateField(
                  "zillow_address",
                  val
                ); 
              }}
              onSelect={this.selectAddress.bind(this)}
              onSearch={this.handleSearch.bind(this)}
              placeholder={""}
            />
            {this.state.zpid ? (
              <Button
                onClick={this.zillowChecker.bind(this)}
                style={{ marginTop: 10 }}
              >
                <Translate text={`Get Value`} />
              </Button>
            ) : (
              <Button disabled style={{ marginTop: 10 }}>
                <Translate text={`Get Value`} />
              </Button>
            )}
          </Card> */}
        {/* </Spin> */}
      </Card>
    );
  }
}

export default ZillowHomeValueContainer;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/zillow-home-value-container.js